import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Start extends Component {
  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          The communication section of the DSN App lets you keep up to date with all your messages, diary and response list. Just tap one of the options below to get started.
        </Typography>
        <Button onClick={() => {this.props.changeRoute("/console/communication/messages");}} className={classes.button} raised color="primary">
          View or Send Messages
        </Button>
        <Button onClick={() => {this.props.changeRoute("/console/my_profiles");}} className={classes.button} raised color="primary">
          Communications Diary
        </Button>
        <Button disabled onClick={() => {this.props.changeRoute("/console/communication/response");}} className={classes.button} raised color="primary">
          Need My Response List
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Start)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Communication/scenes/Start/index.js